
    var riot = require('riot')
    //src: starling/src/tags/node-attribute-menu.html
riot.tag2('node-attribute-menu',
  '<div class="floating-menu_list" ref="floatingMenuEl"> <menu-item-edit-attribute></menu-item-edit-attribute> <div class="floating-menu_divider"></div> <menu-item-remove-attribute></menu-item-remove-attribute> </div>',
  '',
  'class="floating-menu {isOpen ? \'\' : \'floating-menu--hidden\'}"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var canvas = this.opts.canvas;

this.positionSelf = _menuUi.mui.positionSelf.bind(this);

this.summon = function (_ref) {
  var attributeId = _ref.attributeId,
      nodeTag = _ref.nodeTag,
      referenceEl = _ref.referenceEl;

  canvas.hidePopups();
  _this.attributeId = attributeId;
  _this.parentNodeTag = nodeTag;
  _this.positionSelf({ referenceEl: referenceEl, selfEl: _this.refs.floatingMenuEl });
  _this.isOpen = true;
  if (_this.parentNodeTag) {
    var pill = _this.parentNodeTag.refs.container.querySelector('span[data-id=\'' + _this.attributeId + '\']');
    if (pill) {
      pill.classList.add('node-attribute--active');
    }
  }
  _this.update();
};

this.hide = function () {
  _this.isOpen = false;
  if (_this.parentNodeTag) {
    if (!(canvas.nodeAttributeEditor.node && canvas.nodeAttributeEditor.node.id === _this.parentNodeTag.id)) {
      var pill = _this.parentNodeTag.refs.container.querySelector('span[data-id=\'' + _this.attributeId + '\']');
      if (pill) {
        pill.classList.remove('node-attribute--active');
      }
    }
  }

  delete _this.attributeId;
  delete _this.parentNodeTag;
  _this.update();
};

canvas.nodeAttributeMenu = this;
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-attribute-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-attribute-menu.html
// module id = 744
// module chunks = 0